export type CapabilityCategory = {
  name: string;
  items: string[];
};

export const capabilities: CapabilityCategory[] = [
  {
    name: 'Design & Engineering',
    items: [
      'CAD modeling in Fusion 360 & SolidWorks',
      'Custom tooling and jig design',
      'Process optimization for small runs',
      'Technical research & problem analysis',
      'Reverse engineering from drawings or samples'
    ]
  },
  {
    name: 'Fabrication',
    items: [
      'CNC machining to 0.001" on a Nomad 3',
      'Bambu Labs P1S additive prototyping',
      'Sheet metal forming and bending',
      'Precision assembly and fitting',
      'Prototype through 10 to 100 piece production'
    ]
  },
  {
    name: 'Electronics & Automation',
    items: [
      'Cable design and assembly for low noise',
      'Shielding and signal integrity work',
      'Microcontroller integration',
      'Python tooling for automation',
      'Custom test fixture design'
    ]
  },
  {
    name: 'Quality & Inspection',
    items: [
      'Precision metrology and measurement',
      'Digital microscopy for inspection',
      'Electrical diagnostics and validation',
      'Iterative prototyping and tuning',
      'Documentation for repeatable runs'
    ]
  }
];
